import AbstractChatMessage from './AbstractChatMessage'
import { MessageTypes } from '@/constants/chat/MessageTypes'

export default class VacancyApplicationAppliedChatMessage extends AbstractChatMessage {
  type = MessageTypes.VACANCY_APPLICATION_APPLIED

  constructor(data: LX.VacancyApplicationAppliedChatMessage) {
    super(data)
    this.body = data.body
  }

  static fromServer(data: LX.VacancyApplicationAppliedChatMessage) {
    return new VacancyApplicationAppliedChatMessage(data)
  }

  getShortMessage() {
    return 'This position is no longer available.'
  }
}
